export default class LeagueRaceResults {
  rowNumber: number = 0;
  rank: number = 0;
  leagueId: number = 0;
  leagueName: string;
  raceId: number = 0;
  userId: string = '';
  teamId: number = 0;
  teamName: string;
  racePoints: number = 0;
  tieBreakerGap: number = 0;
  bonusPoints: number = 0;
  finishFirstPoints: number = 0;
  finishSecondPoints: number = 0;
  finishThirdPoints: number = 0;
  totalPoints: number = 0;
  lapsCompleted: number = 0;
  totalLaps: number = 0;
  isUser: boolean;
  isPrivate: boolean;
  brandId: number = 0;
  isOfficial: boolean;
  raceName: string;
  raceStatus: string;
  raceLogoUrl: string;

  constructor(starter: any = {}) {
    this.rowNumber = starter.rowNumber || null;
    this.rank = starter.rank || 0;
    this.leagueId = starter.leagueId || null;
    this.leagueName = starter.leagueName || null;
    this.raceId = starter.raceId || null;
    this.userId = starter.userId || null;
    this.teamId = starter.teamId || null;
    this.teamName = starter.teamName || null;
    this.racePoints = starter.racePoints || 0;
    this.tieBreakerGap = starter.tieBreakerGap || 0;
    this.bonusPoints = starter.bonusPoints || 0;
    this.finishFirstPoints = starter.finishFirstPoints || 0;
    this.finishSecondPoints = starter.finishSecondPoints || 0;
    this.finishThirdPoints = starter.finishThirdPoints || 0;
    this.totalPoints = starter.totalPoints || 0;
    this.lapsCompleted = starter.lapsCompleted || 0;
    this.totalLaps = starter.totalLaps || 0;
    this.isUser = starter.isUser ? true : false;
    this.isPrivate = starter.isPrivate ? true : false;
    this.brandId = starter.brandId || null;
    this.isOfficial = starter.isOfficial ? true : false;
    this.raceName = starter.raceName || null;
    this.raceStatus = starter.raceStatus || null;
    this.raceLogoUrl = starter.raceLogoUrl || null;
  }
}
